import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { ModalFoot, Button } from 'mailup-web-components'
import { modalScheduleSendingState } from 'Pages/CampaignsSendStatus/recoil/state/modals'
import { useRecoilValue } from 'recoil'

export const Foot = ({ onClickConfirm, onClickCancel, disabled }) => {
  const intl = useIntl()

  const { sending } = useRecoilValue(modalScheduleSendingState)

  return (
    <ModalFoot>
      <Button
        disabled={sending}
        kind='secondary'
        onClick={onClickCancel}
        data-mu-test='Schedule-mailing-btn-cancel'
      >
        {intl.formatMessage({ id: 'Load.MailupCommon.Cancel' })}
      </Button>
      <Button
        disabled={sending || disabled}
        kind='primary'
        onClick={onClickConfirm}
        data-mu-test='Schedule-mailing-btn-set'
      >
        {intl.formatMessage({ id: 'Load.Schedulation.setScheduleBtImposta' })}
      </Button>
    </ModalFoot>
  )
}

Foot.defaultProps = {
  disabled: false
}

Foot.propTypes = {
  onClickCancel: PropTypes.func,
  onClickConfirm: PropTypes.func,
  disabled: PropTypes.bool
}
